var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".circle-filled{fill:#e1e5eb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circle-filled",
    d: "M36,18A18,18,0,1,1,18,0,18,18,0,0,1,36,18ZM15.278,11.459a1.125,1.125,0,0,0-1.778.916v11.25a1.125,1.125,0,0,0,1.778.916l7.875-5.625a1.125,1.125,0,0,0,0-1.831l-7.875-5.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleFill);
export default __webpack_public_path__ + "static/media/play-circle-fill.38ee5a441670ca31f67d6a384d324a4a.svg";
export { ForwardRef as ReactComponent };